function handleize(str) {
  return str
    .toLowerCase()
    .replace(/[^\w\u00C0-\u024f]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function onFormSubmitCustom(event) {
  event.preventDefault();
  const { variant } = event.dataset;
  const variantId = variant.id;
  const qty = event.dataset.quantity;
  const props = event.dataset.properties || {};
  const timeStamp = parseInt(event.timeStamp);
  const customItems = [
    {
      id: variantId,
      quantity: qty,
      properties: props,
    },
  ];
  if (event.target.elements.addOn && event.target.elements.addOn.checked) {
    customItems.push({
      id: parseInt(event.target.elements.addOn.value),
      quantity: qty,
      properties: {
        _child_item: timeStamp,
      },
    });
  }
  Cart.addItems({ items: customItems }, "pdp");
  const id = event.srcElement.dataset.productId;
  const type = event.srcElement.dataset.productType;
}

const allowedSubstrings = [
  "cass",
  "karsen"
];

function profanityCheck(value) {
  const lowercaseValue = value.toLowerCase();
  const additionalProfanityTest = shop_api.settings.customProfanityFilter?.some(prof => lowercaseValue.includes(prof));
  console.log('additionalProfanityTest', additionalProfanityTest);
  return fetch(
    `https://www.purgomalum.com/service/containsprofanity?text=${value}`
  )
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      if (json || additionalProfanityTest) {
        const profanityMarkup =
          '<div class="confirm-custom"><div class="confirm-custom__main warning"><h2 class="confirm-custom__title">Oops! We can’t personalize that phrase.</h2><p class="confirm-custom__body">Change it up and try again, or <a href="https://puravidabracelets.kustomer.help/contact/contact-us-jn23-ByJPhOe3i">contact customer service</a> if you have any questions.</p></div></div>';
        document.querySelector("[data-dialog-entry]").innerHTML =
          profanityMarkup;
        showDialog("engraving-warning-dialog");
      }
      if (additionalProfanityTest) {
        return true;
      } else {
        return json;
      }
    })
    .catch(function (err) {
      console.log("Failed to fetch ajax cart: ", err);
      return false;
    });
}

async function onFormSubmit(event) {
  console.log("event", event);
  event.preventDefault();
  const { variant } = event.dataset;
  const variantId = variant.id;
  const qty = event.dataset.quantity;
  const props = event.dataset.properties || {};
  const context = props._complete_the_look ? "ctl" : "pdp";
  let selling_plan = null;
  if (event.target.elements.selling_plan) {
    selling_plan = event.target.elements.selling_plan.value;
  }
  if (props["Personalization"]) {
    const personalization = props["Personalization"].toLowerCase();
    if (!allowedSubstrings.some((substring) => personalization.includes(substring))) {
      const profanityTest = await profanityCheck(props["Personalization"]);
      if (profanityTest) {
        return false;
      }
    }
  }
  Cart.addItem(variantId, qty, props, context, selling_plan);
  const id = event.srcElement.dataset.productId;
  const type = event.srcElement.dataset.productType;
}

async function checkBundleItemInventory(
  items,
  quantity,
  cartItems,
  name,
  context
) {
  let inventoryPass = true;
  for (const variant of items) {
    const variantInventory = await fetch(
      `${shop_api.shop.url}${shop_api.routes.root_url}products/${variant.handle}?view=ajax-bundle`
    );
    const inventoryJson = await variantInventory.json();
    const hasEnoughInventory =
      inventoryJson[variant.id].inventory_quantity >= quantity;
    if (!hasEnoughInventory) inventoryPass = false;
  }
  if (inventoryPass) {
    Cart.addItems({ items: cartItems }, context);
    dataLayer.push({
      event: "bundle_add_to_cart",
      item_name: name,
    });
  } else {
    const dialogEntry = document.querySelector("[data-dialog-entry]");
    dialogEntry.innerHTML =
      '<div class="dialog__header">Sorry, this item is no longer available.</div>';
    showDialog("bundle-oos");
  }
}

async function onFormSubmitBundle(event) {
  event.preventDefault();
  const { variant } = event.dataset;
  const variantId = variant.id;
  const qty = event.dataset.quantity;
  const props = event.dataset.properties || {};
  const context = props._complete_the_look ? "ctl" : "pdp";
  if (shop_api.product.variants[variantId].metafields.discount !== null) {
    const uuid = Date.now();
    const discountSpread =
      shop_api.product.variants[variantId].metafields.discount /
      shop_api.product.variants[variantId].metafields.bundleProducts.length;
    props._bundle_discount = discountSpread;
    props._virtual_bundle_discount = discountSpread;
    props._bundle_sibling_id = variantId;
    props._bundle_cart_id = uuid;
    props._bundle_item_count =
      shop_api.product.variants[variantId].metafields.bundleProducts.length;
  }
  const bundleItems = shop_api.product.variants[
    variantId
  ].metafields.bundleProducts.map((item, index) => {
    const lineItemProps = Object.assign({}, props);
    if (shop_api.product.variants[variantId].metafields.bundleParent !== null) {
      if (index === 0) {
        lineItemProps._add_on_parent =
          shop_api.product.variants[variantId].metafields.bundleParent;
      } else {
        lineItemProps._add_on_set =
          shop_api.product.variants[variantId].metafields.bundleParent;
      }
    }
    return {
      id: item.id,
      quantity: qty,
      properties: lineItemProps,
    };
  });
  await checkBundleItemInventory(
    shop_api.product.variants[variantId].metafields.bundleProducts,
    qty,
    bundleItems,
    event.dataset.variant.name,
    context
  );
}

function toggleSubmitBtnState(disabled, text, button) {
  if (button) {
    if (disabled) {
      button.setAttribute("disabled", disabled);
    } else {
      button.removeAttribute("disabled");
    }
    button.querySelector("[data-add-to-cart-text]").innerHTML = text;
  }
}

function toggleAvailableVariants(product, form) {
  form
    .querySelectorAll(".swatch.unavailable")
    .forEach((swatch) => swatch.classList.remove("unavailable"));
  const strikeOutIndex = product.options.length > 1 ? 1 : 0;
  const selectedFirstOption = form.querySelector(
    '[data-swatches-index="0"] input:checked'
  );
  if (!selectedFirstOption) return;
  const selectedFirstOptionValue = selectedFirstOption.value;
  form
    .querySelectorAll(`[data-swatches-index="${strikeOutIndex}"] .swatch`)
    .forEach((swatch) => swatch.classList.add("unavailable"));
  const availableStrikeoutOptions =
    strikeOutIndex === 0
      ? product.variants.filter((variant) => variant.available)
      : product.variants.filter(
          (variant) =>
            variant.option1 === selectedFirstOptionValue && variant.available
        );
  availableStrikeoutOptions.forEach((variant) => {
    const optionName = handleize(
      variant.options[strikeOutIndex].replace("+", "plus").replace("&", "and")
    );
    const swatch = form.querySelector(`[data-swatch="${optionName}"]`);
    if (swatch) swatch.classList.remove("unavailable");
  });
}

function toggleAvailableVariantsReversed(product, form) {
  form
    .querySelectorAll(".swatch.unavailable")
    .forEach((swatch) => swatch.classList.remove("unavailable"));
  const strikeOutIndex = 0;
  const selectedSecondOption = form.querySelector(
    '[data-swatches-index="1"] input:checked'
  );
  if (!selectedSecondOption) return;
  const selectedSecondOptionValue = selectedSecondOption.value;
  form
    .querySelectorAll(`[data-swatches-index="${strikeOutIndex}"] .swatch`)
    .forEach((swatch) => swatch.classList.add("unavailable"));
  const availableStrikeoutOptions = product.variants.filter(
    (variant) =>
      variant.option2 === selectedSecondOptionValue && variant.available
  );
  availableStrikeoutOptions.forEach((variant) => {
    const optionName = handleize(
      variant.options[strikeOutIndex].replace("+", "plus").replace("&", "and")
    );
    const swatch = form.querySelector(`[data-swatch="${optionName}"]`);
    if (swatch) swatch.classList.remove("unavailable");
  });
}

function variantPriceChange(product, variant, form) {
  const money = (cents) =>
    formatMoney(cents, shop_api.shop.moneyFormat).replace(".00", "");
  const price = form.querySelector("[data-product-price]");
  const comparePrice = form.querySelector("[data-compare-price]");
  const badge = document.querySelector("[data-badge]");
  const badgeEntry = document.querySelector("[data-badge-entry]");
  price.innerHTML = money(variant.price);
  if ("shopLookForm" in form.dataset) return;
  if (
    shop_api.product.variants &&
    shop_api.product.variants[variant.id].metafields.script_discount != ""
  ) {
    price.innerHTML =
      shop_api.product.variants[variant.id].metafields.script_discount;
    comparePrice.innerHTML = money(variant.price);
    return;
  }
  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    price.classList.add("on-sale");
    if (comparePrice) {
      comparePrice.innerHTML = money(variant.compare_at_price);
      comparePrice.style.display = "inline";
    } else {
      price.insertAdjacentHTML(
        "afterend",
        `<span class="compare-price" data-compare-price>${money(
          variant.compare_at_price
        )}</span>`
      );
    }
    if (!badge) {
      badgeEntry.innerHTML = `
				<div class="product-badge" data-badge>
					Save ${(
            ((variant.compare_at_price - variant.price) * 100) /
            variant.compare_at_price
          ).toFixed(0)}%
				</div>
			`;
    } else {
      badge.textContent = `
				Save ${(
          ((variant.compare_at_price - variant.price) * 100) /
          variant.compare_at_price
        ).toFixed(0)}%
			`;
    }
  } else if (comparePrice) {
    price.classList.remove("on-sale");
    comparePrice.style.display = "none";
    if (badge && badge.dataset.badge !== "") {
      badge.innerText = badge.dataset.badge;
      if (badge.dataset.badge === "NEW")
        badge.classList.add("product-badge--new");
    } else {
      badgeEntry.innerHTML = "";
    }
  }
}
